package jslibs.keplrwallet.types

import kotlinx.serialization.Serializable

@Serializable
class KeplrSignOptionsImpl(
    override var preferNoSetFee: Boolean? = null,
    override var preferNoSetMemo: Boolean? = null,
    override var disableBalanceCheck: Boolean? = null
) : KeplrSignOptions